export const routes = {
  login: {
    route: `/login`,
    title: 'Login',
  },
  private: {
    route: `/*`,
    title: 'privatePage',
  },
  notFound: {
    route: `/not-found`,
    title: 'notFound',
  },
  dashboard: {
    route: `/Dashboard/*`,
    title: 'Dashboard',
  },
  flightCateringManagement: {
    route: `/flight-catering-management`,
    title: 'Flight Catering management',
  },
  resetPassword: {
    route: `/resetPassword`,
    title: 'resetPassword',
  },
};
